import React, { useRef, useEffect } from 'react'
import Uploads from '../Uploads'
import { useContext } from 'react'
import { store } from '../../stores/multipost'
import classNames from 'classnames'
import ReactDOM from 'react-dom'

export default function FileMenu( {onSelectUpload, isOpen, triggerClose}) {
  const { uploadsComponentData } = useContext(store)

  const menuState = {
    open: isOpen,
    categories: ['photo', 'video'],
    onSelectUpload: onSelectUpload,
  }

  const menuRef = useRef()

  const menuClasses = classNames({
    'uploads-menu': true,
    'open': isOpen,
  })

  const menu = ReactDOM.createPortal((
    <div className={menuClasses} ref={menuRef}>
      <Uploads
        {...uploadsComponentData}
        selfSignUpTrial={false}
        actsAsMenu={true}
        enableGraphics={true}
        key={'photo'}
        uploadMenuState={menuState} />
    </div>
  ), document.body)

  useEffect(() => {
    if (menuState.open) {
      const handleKeyDown = (e) => {
        if (e.keyCode == 27) { // esc
          triggerClose()
        }
      }

      const handleMouseDown = (e) => {
        if (menuState.open &&
          menuState.current &&
          !menuState.current.contains(e.target) &&
          !e.target.closest('.form-select-upload') &&
          !e.target.closest('.pintura-editor') &&
          !e.target.closest('.modal')) {
          triggerClose()
        }
      }
      window.addEventListener("keydown", handleKeyDown, false)
      window.addEventListener("mousedown", handleMouseDown, false)

      return () => {
        window.removeEventListener("keydown", handleKeyDown)
        window.removeEventListener("mousedown", handleMouseDown)
      }
    }
  }, [menuState.open])

  return (
    <>
      {menu}
    </>
  )
}